/**
 * Long-running LLM job copy for proposal/workplan/report generation.
 * Set `VITE_RFP_GENERATION_TIMING_BRAND=keystone` (or use keystone-rfp Vite defaults)
 * for Keystone-specific wording.
 */
function timingBrand(): string | undefined {
  return import.meta.env.VITE_RFP_GENERATION_TIMING_BRAND?.trim().toLowerCase();
}

/** Body copy while a full proposal/report job is running (shown above ReportJobMonitor). */
export function proposalGenerationInProgressBody(): string {
  if (timingBrand() === 'keystone') {
    return (
      'Your proposal is being generated. With the latest models deployed at Keystone, ' +
      'this can take up to about an hour.'
    );
  }
  return (
    'Your proposal is being generated. Full generation can take up to about an hour ' +
    'depending on models and load; many jobs finish sooner.'
  );
}

/** Same intent as {@link proposalGenerationInProgressBody} for workplan flows. */
export function workplanGenerationInProgressBody(): string {
  if (timingBrand() === 'keystone') {
    return (
      'Your workplan is being generated. With the latest models deployed at Keystone, ' +
      'this can take up to about an hour.'
    );
  }
  return (
    'Your workplan is being generated. Full generation can take up to about an hour ' +
    'depending on models and load; many jobs finish sooner.'
  );
}

/** Short note for workplan jobs inside ReportJobMonitor while active. */
export function workplanGenerationRunningFooterNote(): string {
  if (timingBrand() === 'keystone') {
    return (
      'Latest models at Keystone: end-to-end workplan generation can take up to about an hour. ' +
      'You can leave this dialog; the job continues in the background.'
    );
  }
  return (
    'Full workplan generation can take up to about an hour depending on models and load. ' +
    'You can leave this dialog; the job continues in the background.'
  );
}

/** Short note for proposal/report jobs inside ReportJobMonitor while active. */
export function reportGenerationRunningFooterNote(): string {
  if (timingBrand() === 'keystone') {
    return (
      'Latest models at Keystone: end-to-end runs can take up to about an hour. ' +
      'You can leave this page; the job continues in the background.'
    );
  }
  return (
    'Full report generation can take up to about an hour depending on models and load. ' +
    'You can leave this page; the job continues in the background.'
  );
}
